<template>

    <b-container class="pointer container-audit" 
                 @click="openAudit">

        <b-row class="m-0 date-row">

            <span class="light-gray font-roman feed-item-time">
                {{item.CreatedDate}}
            </span>
            
            <b-button variant="light"  
                      :id="`popover-button-sync-${index}`"
                      @click.stop>

                <font-awesome-icon icon="ellipsis-v"                                           
                                    class="light-gray"/>
            </b-button>

            <b-popover  :target="`popover-button-sync-${index}`" 
                        triggers="focus"
                        placement="bottom">

                <b-container class="p-0-20">

                    <b-row :id="`delete-audit-${index}`"
                           class="m-0 pointer popover-red-color"
                           @click="deleteAuditDialog(item)">
                        Удалить
                    </b-row>

                </b-container>
                
            </b-popover>

        </b-row>

        <b-row class="m-0 type-audit">   
            <b-img :src="item.ImagePath"/>    
            
            <span :class="item.Color" 
                    class="p-0-10">
                {{item.Type.Text}}
            </span>
        </b-row>

        <b-row class="m-0 name-audit">
            {{item.Name}}
        </b-row>

        <b-row class="m-0 light-gray font-roman name-activity">
            {{item.TemplateName}}
        </b-row>    

    </b-container>

</template>

<script>
import '@/assets/styles/client/audit/feedItem.css'

import AllRoutes from '@/routes/all.routes.js'
import dialogService from '@/services/dialog.service'

export default {
    props: {
        item:{
            type: Object,
            default: null
        },
        index: {
            type: Number,
            default: 0
        }
    },
    data: function() {
        return {
            show: false
        }
    },
    methods: {

        openAudit: function() {
            this.$router.push({
                name: AllRoutes.Client.Audit.Index,
                query: { id: this.item.Id },
                params: { title:  this.item.Type.Text}
            });
        },  

        deleteAuditDialog: function(audit) {
            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данный аудит?')
                .then(ok => { this.$emit('delete', audit); })
                .catch(cancel => {});
        }
    }
}
</script>